import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CTA_LABEL, site } from '../data/site';
export function HeroSection() {
  return <section id="top" className="court-marks flex min-h-[calc(100svh-2.75rem)] bg-brand-main px-4 pb-6 pt-5 text-center sm:pb-8 sm:pt-6" data-id="element-105" data-mp="23v1jv73rngfk">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-[1120px] flex-col items-center justify-center" data-id="element-106" data-mp="28uxptbw0xhxr">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.18em] text-brand-teal sm:text-[11px]" data-id="element-107" data-mp="2mufhq04m9bbc">
          READY-TO-USE RESOURCES FOR ELEMENTARY &amp; SECONDARY PE
        </p>
        <h1 className="mx-auto max-w-3xl text-[1.75rem] font-black leading-[1.08] tracking-tight text-brand-blue sm:text-[2.6rem] md:text-[3.2rem]" data-id="element-108" data-mp="3fil56un21eev">
          Plan a Full Year of PE in{' '}
          <span className="italic text-brand-orange" data-id="element-109" data-mp="3kb4ehfeplndv">
            Minutes&nbsp;—&nbsp;Not&nbsp;Hours
          </span>
        </h1>
        <p className="mx-auto mt-2.5 max-w-2xl text-[15px] leading-relaxed text-brand-gray md:text-base" data-id="element-110" data-mp="2beq14vx4ourn">
          Stop planning every lesson from scratch. Get a complete, progressive Physical Education system with
          ready-to-use activities, inclusive adaptations, assessments, printable tools, and practical resources for
          Elementary and Secondary classes.
        </p>
        <img src={site.heroImage} alt={site.heroImageAlt} loading="eager" decoding="async" className="mx-auto my-2 h-[26svh] w-auto max-w-[80%] object-contain sm:my-3 sm:h-[30svh] md:h-[34svh]" data-id="element-111" data-mp="2u4ogzy763s5u" />
        <div className="flex w-full max-w-sm flex-col items-center" data-id="element-112" data-mp="335w4dl85b8l5">
          <CTAButton className="w-full" data-id="element-113" data-mp="1dr7rzjzk1qn4">{CTA_LABEL}</CTAButton>
          <p className="mt-2.5 text-[11px] font-semibold leading-relaxed text-brand-gray sm:text-xs" data-id="element-114" data-mp="18r3f03xuve1n">
            Instant access <span className="px-1 text-brand-orange" data-id="element-115" data-mp="38tuuletcf756">•</span> One-time payment{' '}
            <span className="px-1 text-brand-orange" data-id="element-116" data-mp="3ds60jegioxi4">•</span> Lifetime access
          </p>
          <p className="mt-1 text-[11px] text-brand-gray/80" data-id="element-117" data-mp="3irimlwzke0jn">Digital resources. Download and start planning immediately.</p>
        </div>
      </motion.div>
    </section>;
}